const columnSizes = {
	XS: "#ACF6EC",
	S: "#5AEDD9",
	M: "#19E3C8",
	L: "#16CAB2",
	XL: "#119786",
	XXL: "#0E7E6F",
	E: "#074038",
	F: "#A3A3A3",
};

export const useLeadersTable = () => {
	const columns = [
		{
			title: "Líderes",
			dataIndex: "name",
			key: "name",
			fixed: "left",
			width: 64,
			sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
			render: (text, record) => (
				<div className="flex items-center gap-2">
					<div className="w-fit">
						<div className="w-4 h-4 rounded-full" style={{ backgroundColor: record.color }}></div>
					</div>
					<span className="font-semibold text-xs">{text.split(" ").slice(0, 2).join(" ")}</span>
				</div>
			),
		},
		{
			title: "Proyecto",
			dataIndex: "project",
			key: "project",
			width: 60,
			sorter: (a, b) => a.project - b.project,
			render: (text, record) => (
				<div className="mr-4 pr-4">
					<span className={`font-semibold text-xs px-7 py-3 rounded-[10px] w-full block`} style={{ backgroundColor: `${record.color}66` }}>
						{text}
					</span>
				</div>
			),
		},
		...Object.keys(columnSizes).map((size) => ({
			title: (
				<div className="flex items-center gap-2">
					<div className="w-fit">
						<div className={`w-4 h-4 rounded-full`} style={{ backgroundColor: columnSizes[size] }}></div>
					</div>
					<span>{size}</span>
				</div>
			),
			dataIndex: size,
			key: size,
			width: 50,
			sorter: (a, b) => a[size] - b[size],
			render: (text) => (
				<span className={`font-semibold text-xs px-7 py-3 rounded-[10px] w-full block`} style={{ backgroundColor: `${columnSizes[size]}33` }}>
					{text || 0}
				</span>
			),
		})),
	];

	return { columns };
};
